module.exports = __webpack_public_path__ + "static/ims-logo-7aa9e89355496a5cd78eee49d20c400f.png";